import React,{ useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { CustomSelect, Text } from '../../../../common/component';
import { GET_ALL_MEASUREMENT_UNIT } from '../../query';
import { useLazyQuery } from '@apollo/client';
import { catClient } from '../../../../common';

interface IUnitSelectProps{
    onChange:(obj:any)=>void;
    value:any;
    disabled?:boolean;
    backgroundColor?:string;
    width?:string;
    isLabelVisible?:boolean;
    isRequired?:boolean;
    style?:any;
};

const UnitSelect=(props:IUnitSelectProps)=>{
    
    const { onChange, value, disabled,backgroundColor,width,isLabelVisible,isRequired,style } = props;

    const unitValue = !!value ? (Array.isArray(value) ? value : [value]) : []

    const [unitData,setUnitData] = useState([]);

    const [getMeasurementUnitData,{data,called,error,loading}] = useLazyQuery(GET_ALL_MEASUREMENT_UNIT,{ client: catClient, variables:{ perPage : 9999,entityId:localStorage.getItem('default_entity_id') } });

    useEffect(()=>{
        if(!data && !called){
            getMeasurementUnitData({
                variables:{
                    entityId:localStorage.getItem('default_entity_id'),
                    perPage:9999
                }
            });
        }
    },[]);

    useEffect(()=>{
        const derivedUnitData = data && data.getAllMeasurementUnits ? data.getAllMeasurementUnits.map(item => ({ ...item,name:item.name.toUpperCase(), displayName: item.displayName.toUpperCase() })) : [];
        setUnitData(derivedUnitData);
        if (!value?.length && !!derivedUnitData.length) onChange([derivedUnitData?.find(unit => unit.name == 'PC')]);
    },[data, disabled]);

    if(error) return <View style={styles.container}>
        <Text>{error?.message}</Text>
    </View>

    if(!data || loading){
        return <View style={styles.container}>
                <Text>Loading...</Text>
            </View>
    }
    
    return (
        <CustomSelect
            label={"Unit"}
            isClearVisible={true}
            labelField={'displayName'}
            valueField={'name'}
            disabled={disabled}
            key={'name'}
            isLabelVisible={isLabelVisible ?? true}
            searchBy={'displayName'}
            values={unitValue}
            options={unitData}
            isRequired={isRequired ?? true }
            fieldName={"Unit"}
            onChange={(value) => onChange(value)}
            {...(backgroundColor && { backgroundColor })}
            {...(width && { width })}
            {...(style && { style })}
        />
    )
};

export default UnitSelect;

const styles = StyleSheet.create({
    container: {width:150,justifyContent:"center",alignItems:"center"}
})